import { render, staticRenderFns } from "./ConsultarMatriz.vue?vue&type=template&id=7abcacd8&"
import script from "./ConsultarMatriz.vue?vue&type=script&lang=js&"
export * from "./ConsultarMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports